module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門4_7.05a83629.png";